"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconRibbonFilled = void 0;

var React = __importStar(require("react"));

exports.IconRibbonFilled = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "28",
    height: "40",
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M27.4345 35.6497L22.7299 23.7432C22.7315 23.721 22.7363 23.7004 22.7363 23.6799L22.6884 20.4649L25.5142 19.3744C25.74 19.2871 25.9175 19.1005 26.0025 18.8608C26.0873 18.6211 26.0695 18.3541 25.956 18.1298L24.5158 15.3068L26.5448 12.9358C26.7065 12.7475 26.7818 12.4924 26.7545 12.239C26.7258 11.9857 26.5945 11.758 26.396 11.6159L23.8949 9.83375L24.6614 6.72487C24.7222 6.47835 24.679 6.2147 24.5446 6.00415C24.4085 5.7936 24.1941 5.65662 23.9557 5.62925L20.9665 5.2937L20.2944 2.16089C20.2399 1.91095 20.0879 1.69866 19.8767 1.58055C19.6655 1.46243 19.4158 1.44702 19.1934 1.54289L16.401 2.73095L14.4455 0.291457C14.1335 -0.0971524 13.5126 -0.0971524 13.2021 0.291457L11.2467 2.73095L8.45428 1.54289C8.23185 1.44874 7.98223 1.46243 7.77098 1.58055C7.55975 1.69868 7.40613 1.91096 7.35333 2.16089L6.68125 5.2937L3.692 5.62925C3.45518 5.65662 3.23913 5.79187 3.10313 6.00415C2.9671 6.21472 2.9239 6.47835 2.9847 6.72487L3.7512 9.83375L1.25004 11.6159C1.05161 11.758 0.92039 11.9857 0.891588 12.239C0.862785 12.4924 0.939595 12.7475 1.10122 12.9358L3.1303 15.3068L1.6901 18.1298C1.57649 18.3541 1.55889 18.6211 1.6437 18.8608C1.72851 19.1005 1.90613 19.287 2.13177 19.3744L4.95775 20.4649L4.91455 23.3906L0.0641877 35.6497C-0.0654326 35.9802 0.00497967 36.3603 0.241812 36.6138C0.480245 36.8653 0.837088 36.9372 1.14433 36.7952L5.3499 34.8452L6.9725 39.4315C7.09093 39.767 7.38855 39.9912 7.723 39.9982H7.739C8.06705 39.9982 8.36468 39.7878 8.49433 39.4625L13.7494 26.1658L19.0045 39.4642C19.1325 39.7895 19.4302 40 19.7599 40H19.7759C20.1103 39.9932 20.408 39.769 20.5264 39.4333L22.1506 34.847L26.3562 36.797C26.6635 36.939 27.0202 36.867 27.2587 36.6155C27.4955 36.362 27.5657 35.98 27.4345 35.6497ZM7.7819 36.7643L6.57853 33.3643C6.49853 33.14 6.3369 32.9603 6.13045 32.8678C5.92403 32.7738 5.6904 32.7755 5.48555 32.8713L2.3683 34.3162L6.24728 24.5001L8.81085 24.1218L10.1646 26.9928C10.2718 27.2205 10.4671 27.3883 10.7007 27.448C10.9328 27.5098 11.1776 27.4583 11.3728 27.3113L11.5777 27.1552L7.7819 36.7643ZM22.0126 32.8713C21.8062 32.7755 21.5742 32.7755 21.3678 32.8678C21.1613 32.962 20.9997 33.14 20.9197 33.3643L19.7163 36.7643L15.8581 27.0012L16.2646 27.311C16.4054 27.4173 16.5718 27.4738 16.7399 27.4738C16.8055 27.4738 16.8711 27.465 16.9367 27.448C17.1687 27.3863 17.364 27.2203 17.4728 26.9925L18.8266 24.1217L21.2413 24.4778L25.1283 34.3162L22.0126 32.8713Z",
    fill: color
  }));
});